import React, { useMemo } from 'react';
import { Tabs } from '@adobe/react-spectrum';
import { DeepLinkContextProvider, useDeepLinkContext, useDeepLinkSegment } from './useDeepLinkSegment';

export function DeepLinkTabs({ defaultSelectedKey, onSelectionChange, children, ...rest }) {
    const { depth, defaults } = useDeepLinkContext();
    const [selectedKey, setSelectedKey] = useDeepLinkSegment(defaultSelectedKey);

    const handleChange = (key) => {
        setSelectedKey(key);
        onSelectionChange?.(key);
    };

    const childContext = useMemo(
        () => ({ depth: depth + 1, defaults: [...defaults, defaultSelectedKey] }),
        [depth, defaults, defaultSelectedKey]
    );

    return (
        <DeepLinkContextProvider value={childContext}>
            <Tabs
                {...rest}
                defaultSelectedKey={defaultSelectedKey}
                selectedKey={selectedKey}
                onSelectionChange={handleChange}
            >
                {children}
            </Tabs>
        </DeepLinkContextProvider>
    );
}
